import { Stack } from '@mui/material';
import { CasMRTableExportOptionMenu } from 'src/compass/shared/components';
import CommissisonsTotalView from './_internal/CommissisonsTotalView';

type TopToolbarProps = {
  total: number;
  totalLabel?: string;
  exportUrl?: string;
  exportParams?: Record<string ,any>
};

export default function PreliminaryCommissionsTopToolbar({
  total,
  totalLabel,
  exportUrl,
  exportParams,
}: TopToolbarProps) {
  return (
    <Stack flex={1} flexDirection="row">
      <div>{CommissisonsTotalView(total, totalLabel)}</div>
      {exportUrl && CasMRTableExportOptionMenu(exportUrl, exportParams)}
    </Stack>
  );
}
